import { getData } from "../../framework/API/api";
import { ENTITYNAME, LOCALSTORAGE_KEY, MEDIACATEGORIES, MEDIACATEGORYTYPES, SCHEDULETYPE } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";
import * as API from '../../framework/API/api'
import _ from "underscore";
import moment from "moment";

const getCheckListGridItemStructure = (data, message) => {

    let gridData = []
    if (data.length > 0) {
        gridData = data.map((obj) => {
            return {
                _id : obj._id,
                Title: obj.mediaEpisode.Title,
                SlotDateTime: utility.convertMilisecondsToDateTimeString(obj.SlotDateTime),
                AssetId: obj.mediaEpisode.AssetId,
                Type: Object.keys(SCHEDULETYPE).find(key => SCHEDULETYPE[key] === obj.Type) ?? obj.mediaEpisode.MediaCategory.Description,
                Message: message,
            }
        })
    }
    return gridData;

}

//to check if same commercial are scheduled back to back
export const getBackToBackMediaInSchedule = async (data) => {
    let allChildrens = [];
    let backToBackMediaList = [];

    if (data.length != 0) {
        data.map((parent) => {
            allChildrens = [...allChildrens, ...parent.children];
        })
    }

    //allChildrens orderBy SlotDateTime
    allChildrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);

    for (let i = 0; i < allChildrens.length - 1; i++) {
        if (allChildrens[i].Type > SCHEDULETYPE.Segment && allChildrens[i].MediaEpisode_id == allChildrens[i + 1].MediaEpisode_id) {
            backToBackMediaList.push(allChildrens[i]);
        }
    }

    let gridData = getCheckListGridItemStructure(backToBackMediaList, 'Back to back media');
    return gridData;

}

//to get if same brand are scheduled back to back
export const getBackToBackBrandsInSchedule = async (data) => {
    let allChildrens = [];
    let backToBackBrandMediaList = [];

    if (data.length != 0) {
        data.map((parent) => {
            allChildrens = [...allChildrens, ...parent.children];
        })
    }

    //allChildrens orderBy SlotDateTime
    allChildrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);

    for (let i = 0; i < allChildrens.length - 1; i++) {
        if (allChildrens[i].Type > SCHEDULETYPE.Segment && allChildrens[i].mediaEpisode != undefined && allChildrens[i + 1].mediaEpisode != undefined) {
            if (allChildrens[i].mediaEpisode.Brand != undefined && allChildrens[i + 1].mediaEpisode.Brand != undefined && allChildrens[i].mediaEpisode.Brand._id == allChildrens[i + 1].mediaEpisode.Brand._id) {
                backToBackBrandMediaList.push(allChildrens[i]);
            }
        }
    }

    let gridData = getCheckListGridItemStructure(backToBackBrandMediaList, 'Media with back to back same brand');
    return gridData;

}

//to get if same product are scheduled back to back
export const getBackToBackProductsInSchedule = async (data) => {
    let allChildrens = [];
    let backToBackProductMediaList = [];

    if (data.length != 0) {
        data.map((parent) => {
            allChildrens = [...allChildrens, ...parent.children];
        })
    }

    //allChildrens orderBy SlotDateTime
    allChildrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);

    for (let i = 0; i < allChildrens.length - 1; i++) {
        if (allChildrens[i].Type > SCHEDULETYPE.Segment && allChildrens[i].mediaEpisode != undefined && allChildrens[i + 1].mediaEpisode != undefined) {
            if (allChildrens[i].mediaEpisode.Product != undefined && allChildrens[i + 1].mediaEpisode.Product != undefined && allChildrens[i].mediaEpisode.Product._id == allChildrens[i + 1].mediaEpisode.Product._id) {
                backToBackProductMediaList.push(allChildrens[i]);
            }
        }
    }

    let gridData = getCheckListGridItemStructure(backToBackProductMediaList, 'Media with back to back same product');
    return gridData;

}

//to get the headers with underrun and overrun
export const getUnderRunAndOverRunInSchedule = async (data) => {

    let mediaListWithUnderRunOverRun = [];

    for (let i = 0; i < data.length; i++) {

        let underRunOverRunData = data[i].children.filter((item) => item.Type == SCHEDULETYPE.UnderRun || item.Type == SCHEDULETYPE.OverRun);

        if (underRunOverRunData.length != 0) {
            mediaListWithUnderRunOverRun.push(data[i]);
        }
    }

    let gridData = getCheckListGridItemStructure(mediaListWithUnderRunOverRun, 'OverRun / UnderRun ');
    return gridData;

}

//DONE
export const hasNoSegments = async (data) => {

    let hasNoSegments = [];

    for (let i = 0; i < data.length; i++) {

        let segments = data[i].children.filter((item) => item.Type == SCHEDULETYPE.Segment);

        if (segments.length == 0) {
            hasNoSegments.push(data[i]);
        }
    }

    let gridData = getCheckListGridItemStructure(hasNoSegments, 'Not Segmented');
    return gridData;

}

//DONE
export const segmentSequence = async (data) => {

    let hasWrongSequence = [];

    for (let i = 0; i < data.length; i++) {

        let segments = data[i].children.filter((item) => item.Type == SCHEDULETYPE.Segment);

        if (segments.length > 0) {
            segments.map((x, i) => {
                if (x.BreakNo != i + 1) {
                    hasWrongSequence.push(x)
                }
            })
        }
    }

    let gridData = getCheckListGridItemStructure(hasWrongSequence, 'Wrong Sequence');
    return gridData;

}

//DONE
export const getBackToBackCommercialInSchedule = async (data) => {
    let allChildrens = [];
    let backToBackCommercialList = [];

    if (data.length != 0) {
        data.map((parent) => {
            allChildrens = [...allChildrens, ...parent.children];
        })
    }

    //allChildrens orderBy SlotDateTime
    allChildrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);

    for (let i = 0; i < allChildrens.length - 1; i++) {
        if (allChildrens[i].Type > SCHEDULETYPE.Segment && allChildrens[i].mediaEpisode.MediaCategory.SID == MEDIACATEGORIES.Commercial && allChildrens[i].MediaEpisode_id == allChildrens[i + 1].MediaEpisode_id) {
            backToBackCommercialList.push(allChildrens[i]);
        }
    }

    let gridData = getCheckListGridItemStructure(backToBackCommercialList, 'Back to back Commercial');
    return gridData;

}

//DONE
export const getSameBreakSameCommercial = async (data) => {

    let sameBreakSameCommercial = [];

    if (data.length != 0) {
        data.map((parent) => {
            let childrens = parent.children;

            //allChildrens orderBy SlotDateTime
            childrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);

            //FIND DISTINCT BreakNo.
            const distinctBreakNo = [...new Set(childrens.map(obj => obj.BreakNo))];

            for (let i = 0; i < distinctBreakNo.length - 1; i++) {
                const commercialWithSameBreakNo = childrens.filter((x) =>
                    x.BreakNo == distinctBreakNo[i] &&
                    x.Type != SCHEDULETYPE.OverRun && x.Type != SCHEDULETYPE.UnderRun &&
                    x.mediaEpisode.MediaCategory.SID == MEDIACATEGORIES.Commercial
                );

                const uniqMediaEpisodeId = [...new Set(commercialWithSameBreakNo.map(obj => obj.MediaEpisode_id))];
                uniqMediaEpisodeId.map((id) => {
                    let data = commercialWithSameBreakNo.filter((x) => x.MediaEpisode_id == id);
                    if (data.length > 1) sameBreakSameCommercial.push(...data)
                })
            }
        })
    }

    let gridData = getCheckListGridItemStructure(sameBreakSameCommercial, 'Same Break Same Commercial');
    return gridData;

}

//DONE
export const getSameBreakSameBrand = async (data) => {

    let sameBreakSameBrand = [];

    if (data.length != 0) {
        data.map((parent) => {
            let childrens = parent.children;

            //allChildrens orderBy SlotDateTime
            childrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);

            //FIND DISTINCT BreakNo.
            const distinctBreakNo = [...new Set(childrens.map(obj => obj.BreakNo))];

            for (let i = 0; i < distinctBreakNo.length - 1; i++) {
                const mediaWithSameBreakNo = childrens.filter((x) => x.BreakNo == distinctBreakNo[i] && x.mediaEpisode.Brand != undefined);
                const uniqBrandId = [...new Set(mediaWithSameBreakNo.map(obj => obj.mediaEpisode.Brand?._id))];

                uniqBrandId.map((id) => {
                    let data = mediaWithSameBreakNo.filter((x) => x.mediaEpisode.Brand?._id == id);
                    if (data.length > 1) sameBreakSameBrand.push(...data)
                })
            }
        })
    }

    let gridData = getCheckListGridItemStructure(sameBreakSameBrand, 'Same Break Same Brand');
    return gridData;

}


//DONE
export const checkPreviewed = async (data) => {

    let nonPreviewedData = [];
    let noSegmentAttachmentData = [];
    let nonTXReadyData = [];

    for (let i = 0; i < data.length; i++) {

        const header = data[i]

        if (header.Segment_id == undefined || header.Segment_id.length == 0) continue;

        const mediaEpisodeSegment = await getData(ENTITYNAME.MediaEpisodeSegment, { query: ['_id', '=', header?.Segment_id] });

        let segmentDetails = mediaEpisodeSegment.data[0].SegmentDetails;

        //PREVIEWED
        let nonPreviewed = segmentDetails.filter((x) => x.IsPreviewed == undefined || !x.IsPreviewed);
        if (nonPreviewed.length > 0) {
            nonPreviewedData = [...nonPreviewedData, header];
        }

        //TXREADY
        if (mediaEpisodeSegment.data[0].TXReady == undefined || !mediaEpisodeSegment.data[0].TXReady) {
            nonTXReadyData = [...nonTXReadyData, header];
        }

        //TXREADY
        if (mediaEpisodeSegment.data[0].Subtitle == undefined || !mediaEpisodeSegment.data[0].Subtitle) {
            noSegmentAttachmentData = [...noSegmentAttachmentData, header];
        }

    }


    let gridData = {
        Previewed: getCheckListGridItemStructure(nonPreviewedData, 'Have non Previewed Segment'),
        TXReady: getCheckListGridItemStructure(nonTXReadyData, 'Not Tx Ready'),
        Subtitle: getCheckListGridItemStructure(noSegmentAttachmentData, 'No segment attachment')
    };

    // if(nonPreviewedData.length > 0){
    //     gridData.Previewed = nonPreviewedData //getCheckListGridItemStructure(nonPreviewedData,'Not Previewed')];
    // }
    // if(nonTXReadyData.length > 0){
    //     gridData.TXReady = nonTXReadyData //getCheckListGridItemStructure(nonTXReadyData,'Not Tx Ready');
    // }
    // if(noSegmentAttachmentData.length > 0){
    //     gridData.Subtitle = noSegmentAttachmentData //getCheckListGridItemStructure(noSegmentAttachmentData,'No segment attachment');
    // }

    return gridData;

}

//DONE
export const checkSegmentTXReady = async (data) => {

    let nonTXReadyData = [];

    for (let i = 0; i < data.length; i++) {

        const header = data[i]

        if (header.Segment_id == undefined || header.Segment_id.length == 0) continue;

        const mediaEpisodeSegment = await getData(ENTITYNAME.MediaEpisodeSegment, { query: ['_id', '=', header?.Segment_id] });

        //TXREADY
        if (mediaEpisodeSegment.data[0].TXReady == undefined || !mediaEpisodeSegment.data[0].TXReady) {
            nonTXReadyData = [...nonTXReadyData, header];
        }

    }


    let gridData = getCheckListGridItemStructure(nonTXReadyData, 'Not Tx Ready')
    return gridData;

}

//DONE
export const missingSegmentAttachment = async (data) => {

    let noSegmentAttachmentData = [];


    for (let i = 0; i < data.length; i++) {

        const header = data[i]

        if (header.Segment_id == undefined || header.Segment_id.length == 0) continue;

        const mediaEpisodeSegment = await getData(ENTITYNAME.MediaEpisodeSegment, { query: ['_id', '=', header?.Segment_id] });

        if (mediaEpisodeSegment.data[0].Subtitle) {
            let keys = Object.keys(mediaEpisodeSegment.data[0].SubtitleType);
            if (keys.length == 0 || mediaEpisodeSegment.data[0].File.length == 0) {
                noSegmentAttachmentData = [...noSegmentAttachmentData, header];
            }
        } else {
            noSegmentAttachmentData = [...noSegmentAttachmentData, header];
        }

    }


    let gridData = getCheckListGridItemStructure(noSegmentAttachmentData, 'No segment attachment')
    return gridData;

}

//DONE
export const compareSegments = async (data) => {

    let compareSegments = [];

    for (let i = 0; i < data.length; i++) {

        const header = data[i];

        let childrenSegments = header.children.filter((x) => x.Type == SCHEDULETYPE.Segment);

        if (header.Segment_id == undefined || header.Segment_id.length == 0) continue;

        const mediaEpisodeSegment = await getData(ENTITYNAME.MediaEpisodeSegment, { query: ['_id', '=', header.Segment_id] });

        let segmentDetails = mediaEpisodeSegment.data[0].SegmentDetails;

        if (segmentDetails.length != childrenSegments.length) {
            compareSegments.push(header);
        }


    }


    let gridData = getCheckListGridItemStructure(compareSegments, 'Segment Count Mismatch')
    return gridData;

}

//DONE
export const checkTimeRange = async (data) => {
    let allChildrens = [];
    let inValidTimeRangeBookedData = [];

    if (data.length != 0) {
        data.map((parent) => {
            allChildrens = [...allChildrens, ...parent.children];
        })
    }

    allChildrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);
    let bookedData = allChildrens.filter((x) => x.Booking_id && x.Booking_id.length > 0);

    for (let i = 0; i < bookedData.length; i++) {
        const bookingItem = bookedData[i];
        //check time range
        // let [slotData,slotTime] = utility.convertMilisecondsToDateTimeString(bookingItem.SlotDateTime).split(' ');
        // let slotTimeInMilli = utility.convertStringWithFramesToMilliseconds(slotTime);

        const validBookingStartTime = bookingItem.booking.BookingDate + bookingItem.booking.TimeRangeFrom;
        const validBookingEndTime = bookingItem.booking.BookingDate + bookingItem.booking.TimeRangeTo;
        let baseStartTime = bookingItem.SlotDateTime;

        //CASE FOR NEXT DAY BOOKING  23:00 - 04:00
        if (bookingItem.booking.TimeRangeFrom > bookingItem.booking.TimeRangeTo) {
            let date = new Date(validBookingEndTime);
            const updatedValidBookingEndTime = date.setDate(date.getDate() + 1);

            if (baseStartTime < validBookingStartTime || baseStartTime > updatedValidBookingEndTime) {

                inValidTimeRangeBookedData.push(bookingItem);
            }

        }

        else if (baseStartTime < validBookingStartTime || baseStartTime > validBookingEndTime) {
            inValidTimeRangeBookedData.push(bookingItem);
        }

    }

    let gridData = getCheckListGridItemStructure(inValidTimeRangeBookedData, 'wrong Time Range')
    return gridData;

}

//DONE
export const clashCheck = async () => {

    let localStorageScheduleFilterData = utility.getSeassionValue(
        LOCALSTORAGE_KEY.publishData
    );

    let millisecondInOneDay = 86400000;

    let fromDate = localStorageScheduleFilterData.SlotDateTime - 7200000;
    let toDate = localStorageScheduleFilterData.SlotDateTime + millisecondInOneDay + 7200000

    let payload = {
        "Channel": localStorageScheduleFilterData.Channel.SID,
        "FromDate": fromDate,
        "ToDate": toDate
    }

    let clashCheckRes = await API.getProgramScheduleClash(payload);
    console.log(clashCheckRes);

    let finalData = clashCheckRes.data.map((x) => {
        return {
            MovieName: x.MovieName,
            SourceSlotDateTime: utility.convertMilisecondsToDateTimeString(x.SourceSlotDateTime),
            ClashedSlotDateTime: utility.convertMilisecondsToDateTimeString(x.ClashedSlotDateTime),
            SourceChannel: x.Channel.FullChannelName,
            ClashedChannel: x.clashChannel.FullChannelName
        }
    })

    return finalData;

}

//DONE
export const checkSalesBreakLimit = async (data) => {

    let inValidTimeRangeCommercialData = [];

    let timerange = await API.getDataLookup(ENTITYNAME.TimeRange, { sort: { SID: 1 } });

    for (let i = 0; i < timerange.data.length; i++) {

        const timeRange = timerange.data[i];

        let timeIn = utility.convertShortTimeStringToMilliSeconds(timeRange.TimeIn);
        let timeOut = utility.convertShortTimeStringToMilliSeconds(timeRange.TimeOut);
        let commercialLimit = timeRange.CommercialLimit

        data.map((x) => {
            let [slotData, slotTime] = utility.convertMilisecondsToDateTimeString(x.SlotDateTime).split(' ');
            let slotTimeInMilli = utility.convertStringWithFramesToMilliseconds(slotTime);

            if (slotTimeInMilli > timeIn && slotTimeInMilli < timeOut) {
                let commercialInTimeRange = x.children.filter((y) => y.mediaEpisode.MediaCategory != undefined && y?.mediaEpisode?.MediaCategory?.SID == MEDIACATEGORIES.Commercial)
                let commercialDuration = commercialInTimeRange.reduce((acc, value) => {
                    return acc + value.mediaEpisode.Duration
                }, 0);
                // console.log(commercialInTimeRange)
                // console.log(commercialDuration);
                if (commercialDuration > commercialLimit) {
                    inValidTimeRangeCommercialData.push(x);
                }
            }
        })

    }

    let gridData = getCheckListGridItemStructure(inValidTimeRangeCommercialData, 'Exceeding Commercial Limit')
    return gridData;

}

//DONE
export const checkSecondaryEventScheduled = async (data) => {

    // console.log(data);
    let noProtoType = [];

    if (data.length != 0) {
        data.map((parent) => {
            let children = parent.children;
            if (parent.Prototypes.length == 0) {
                let hasPrototypes = children.filter((x) => x?.Prototypes?.length > 0);
                if (hasPrototypes.length == 0) {
                    noProtoType.push(parent)
                }
            }
        })
    }

    let gridData = getCheckListGridItemStructure(noProtoType, 'No Secondary Events')
    return gridData;

}

//DONE
export const checkSecondaryEventDuplication = async (data) => {

    let protoTypeDuplication = [];

    if (data.length != 0) {
        data.map((parent) => {
            let children = parent.children;

            for (let i = 0; i < children.length; i++) {
                const program = children[i];
                if (program?.Prototypes?.length > 0) {
                    //CHECK DUPLICATE
                    let temp_id = [];
                    let tempStartOffset = []
                    program.Prototypes.map((x) => {
                        if (temp_id.includes(x._id) && tempStartOffset.includes(x.StartOffset)) {
                            protoTypeDuplication.push(program)
                        } else {
                            temp_id.push(x._id);
                            tempStartOffset.push(x.StartOffset)
                        }
                    })
                    // console.log(temp);
                }
            }
        })
    }

    let gridData = getCheckListGridItemStructure(protoTypeDuplication, 'Duplicate Secondary Events')
    return gridData;

}

//DONE
export const checkValidDate = async (data) => {

    let inValidData = [];

    for (let i = 0; i < data.length; i++) {

        if (!data[i].IsValid) {
            inValidData.push(data[i])
        }

    }

    let gridData = getCheckListGridItemStructure(inValidData, 'Invalid Dates');
    return gridData;


}

//to get the breaks with underrun
export const getBreakUnderRun = async (data) => {

    let breakWithUnderRun = [];

    for (let i = 0; i < data.length; i++) {

        let breakItemData = data[i].children.filter((item) => item?.IsBreak == true);
        for (let j = 0; j < breakItemData.length; j++) {
            const breakItem = breakItemData[j];
            let breakItemChildrens = breakItem.children.filter((obj) => obj.Type == SCHEDULETYPE.UnderRun);
            if (breakItemChildrens.length > 0) {
                breakWithUnderRun.push(breakItem);
            }

        }
    }

    let gridData = getCheckListGridItemStructure(breakWithUnderRun, 'Break UnderRun ');
    return gridData;

}

//to get the breaks with overrun
export const getBreakOverRun = async (data) => {

    let breakWithOverRun = [];

    for (let i = 0; i < data.length; i++) {

        let breakItemData = data[i].children.filter((item) => item?.IsBreak == true);
        for (let j = 0; j < breakItemData.length; j++) {
            const breakItem = breakItemData[j];
            let breakItemChildrens = breakItem.children.filter((obj) => obj.Type == SCHEDULETYPE.OverRun);
            if (breakItemChildrens.length > 0) {
                breakWithOverRun.push(breakItem);
            }

        }
    }
    let gridData = getCheckListGridItemStructure(breakWithOverRun, 'Break UnderRun ');
    return gridData;

}

export const checkClientSpotSeperation = async (data) => {
    let allChildrens = [];
    let invalidData = [];


    if (data.length != 0) {
        data.map((parent) => {
            allChildrens = [...allChildrens, ...parent.children.filter((x) => x.Booking_id?.length > 0)];
        })
    }

    //allChildrens orderBy SlotDateTime
    allChildrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);

    for (let i = 0; i < allChildrens.length; i++) {

        const bookedSpot = allChildrens[i];

        if (bookedSpot.Client && bookedSpot.Client.SpotSeparation > 0) {

            let timeRangeFrom = bookedSpot.SlotDateTime - bookedSpot.Client?.SpotSeparation;
            let timeRangeTo = bookedSpot.SlotDateTime + bookedSpot.Client?.SpotSeparation;

            let filterData = allChildrens.filter((x) => x.Booking_id != bookedSpot.Booking_id && x.Client?.SID == bookedSpot.Client.SID && x.SlotDateTime >= timeRangeFrom && x.SlotDateTime <= timeRangeTo);

            if (filterData.length > 0) {
                invalidData.push(bookedSpot);
            }

        }
    }

    let gridData = getCheckListGridItemStructure(invalidData, 'Client Spot Seperation');
    console.log(gridData);
    return gridData;

}

export const getInvalidSlotPlanning = async (data) => {
    let invalidData = data.filter((x) => x.InvalidReason != "");
    let gridData = []
    if (invalidData.length > 0) {
        gridData = invalidData.map((obj) => {
            return {
                Title: obj.mediaEpisode.Title,
                SlotDateTime: utility.convertMilisecondsToDateTimeString(obj.SlotDateTime),
                AssetId: obj.mediaEpisode.AssetId,
                Type: Object.keys(SCHEDULETYPE).find(key => SCHEDULETYPE[key] === obj.Type) ?? obj.mediaEpisode.MediaCategory.Description,
                Message: obj.InvalidReason,
            }
        })
    }
    return gridData;
}

export const getEpisodeSequencePlanning = async (data) => {
    let seasonData = data.filter((x) => x.mediaEpisode.Season_id != undefined);
    if (seasonData.length == 0) {
        return [];
    }

    let finalData = [];

    let groupBySeasonId = _.groupBy(seasonData, (item) => item.mediaEpisode.Season_id);

    for (const [key, value] of Object.entries(groupBySeasonId)) {
        for (let i = 0; i < value.length - 1; i++) {
            if (value[i].mediaEpisode.EpisodeNumber > value[i + 1].mediaEpisode.EpisodeNumber) {
                if (value[i + 1].mediaEpisode.EpisodeNumber == 1) {
                    continue;
                }
                finalData.push(value[i + 1]);
            }
        }
    }
    let gridData = getCheckListGridItemStructure(finalData, 'Invalid Episode Sequence');
    return gridData;
};

export const getSegmentAttachedPlanning = async (data) => {
    let segmentAttachedData = data?.filter((x) => x?.segments?.length == 0 || x?.segments == undefined);
    let gridData = getCheckListGridItemStructure(segmentAttachedData, 'Segment not attached');
    return gridData;
}

export const checkValidMedia = async (data) => {
    let gridData = [];
    let invalidArchiveData = [];
    let invalidPublishData = [];

    for (const element of data) {
        element.children.forEach((item) => {
            if (item?.mediaEpisode?.Archive) {
                invalidArchiveData.push(item);
            }
            else {
                if (item?.Type == SCHEDULETYPE.ShortForm && item?.mediaEpisode?.Publishings?.length > 0) {

                    let publishData = item.mediaEpisode.Publishings;

                    let inValidMedia = publishData.some((x) => {
                        
                        let isTBA = x.TBA ?? false;
                        let scheduleDateDay = new Date(item.ScheduleDate).getUTCDay()
                        let isDayRight = x.Days.includes(scheduleDateDay.toString());
                        let isChannelMatch = x.Channel.some(y => y.SID == item.Channel.SID);

                        return !(x.PublishStartDate <= item.ScheduleDate && (isTBA || x.PublishEndDate >=  item.ScheduleDate) && isDayRight && isChannelMatch)

                    })

                    if (inValidMedia) {
                        invalidPublishData.push(item);
                    }

                }
            }
        });
    }
    gridData = getCheckListGridItemStructure(invalidArchiveData, 'Archived');
    gridData = [...gridData, ...getCheckListGridItemStructure(invalidPublishData, 'Invalid Publishing Rights')];
    return gridData;
}

export const checkBackToBackMediaCategoryType = async (data) => {
    let gridData = [];
    let backToBackMediaCategoryType = [];
    let storePrevMediaCategoryType = '';
    for (const element of data) {
        let finalData = element.children.filter((x) => x?.Type == SCHEDULETYPE.ShortForm);
        finalData.forEach((item) => {
            if (storePrevMediaCategoryType == item?.mediaEpisode?.MediaCategoryType?.SID) {
                backToBackMediaCategoryType.push(item);
            }
            storePrevMediaCategoryType = item?.mediaEpisode?.MediaCategoryType?.SID;
        });
    }
    gridData = getCheckListGridItemStructure(backToBackMediaCategoryType, 'Back to Back Media Category Type');
    return gridData;
}

export const validateTimeCodeAndDuration = async (data) => {
    let gridData = [];
    let invalidTimeCode = [];
    
    for (const element of data) {
        let finalData = element.children.filter(x => x.Type != SCHEDULETYPE.UnderRun && x.Type != SCHEDULETYPE.OverRun);
        finalData.forEach((item) => {

            const durationByTimeCode = item.TcOut - item.TcIn;
            if (durationByTimeCode != item.Duration) {
                invalidTimeCode.push(item);
            }
        });
    }
    gridData = getCheckListGridItemStructure(invalidTimeCode, 'Invalid Time Code or Duration');
    return gridData;
}


export const BackToBackSameEpisodeCheck = async (data) => {

    let headers = data.sort((a, b) => a.SlotDateTime - b.SlotDateTime);
    let backToBackSameEpisodeCheck = [];

    if (data.length !== 0) {
        // Check for back-to-back same episodes in the same index
        headers.map((header, index) => {
            if (index < headers.length - 1 && header.MediaEpisode_id === headers[index + 1].MediaEpisode_id) {
                backToBackSameEpisodeCheck.push(header);
            }
        });
    }    
    let gridData = getCheckListGridItemStructure(backToBackSameEpisodeCheck, 'Episode with back to back same Episode');
    return gridData;
}

export const validatePreviousDayEndTime = async (scheduleTimeInfo) => {

    //CHECK IF PREVIOUS DAY END TIME = TODAY'S START TIME
    let isValid = utility.convertStringWithFramesToMilliseconds(scheduleTimeInfo.PreviousScheduleEndDateTime) == utility.convertStringWithFramesToMilliseconds(scheduleTimeInfo.StartDateTime);

    return isValid;
    
}

export const CommercialLimitPerHour = async (data, offset = 0) => {

    let timeRangeRes = await API.getDataLookup(ENTITYNAME.TimeRange, { sort: { SID: 1 } });
    let headers = data.sort((a, b) => a.SlotDateTime - b.SlotDateTime);

    let date = moment(new Date(data[0].SlotDateTime)).format("YYYY-MM-DD");

    let commercialOverFlowHeader = [];

    if(timeRangeRes.success && timeRangeRes.data.length > 0){
        
        for (let i = 0; i < timeRangeRes.data.length; i++) {
            const timeRange = timeRangeRes.data[i];

            let fromTime = utility.convertStringDatetoMilliseconds(date) + utility.convertShortTimeStringToMilliSeconds(timeRange.TimeIn) + offset;
            let toTime = utility.convertStringDatetoMilliseconds(date) + utility.convertShortTimeStringToMilliSeconds(timeRange.TimeOut) + offset;
            
            let headersUnderTimeRange = headers.filter((x) => x.SlotDateTime >= fromTime && x.SlotDateTime < toTime);
            let commercialsUnderTimeRange = [];

            headersUnderTimeRange.map((x) => {

                let commercials = x.children.filter((y) => y.Type == SCHEDULETYPE.ShortForm && y.mediaEpisode.MediaCategory.SID == MEDIACATEGORIES.Commercial);
                commercialsUnderTimeRange = [...commercialsUnderTimeRange, ...commercials];

            });

            if(timeRange.CommercialLimit < commercialsUnderTimeRange.reduce((acc, value) => { return acc + value.Duration }, 0)){
                commercialOverFlowHeader.push(...headersUnderTimeRange);
            }
        }
    }

    let gridData = getCheckListGridItemStructure(commercialOverFlowHeader, 'Header with commercial limit overflow');
    return gridData;
}

export const getSameBreakSameCampaign = async (data) => {

    let sameBreakSameCampaign = [];

    if (data.length != 0) {
        data.map((parent) => {
            let childrens = parent.children;

            //allChildrens orderBy SlotDateTime
            childrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);

            //FIND DISTINCT BreakNo.
            const distinctBreakNo = [...new Set(childrens.map(obj => obj.BreakNo))];

            for (let i = 0; i < distinctBreakNo.length - 1; i++) {
                const campaignWithSameBreakNo = childrens.filter((x) => x.BreakNo == distinctBreakNo[i] && x.Booking_id);

                const uniqCampaignId = [...new Set(campaignWithSameBreakNo.map(obj => obj.Campaign._id))];
                uniqCampaignId.map((id) => {
                    let data = campaignWithSameBreakNo.filter((x) => x.Campaign._id == id);
                    if (data.length > 1) sameBreakSameCampaign.push(...data)
                })
            }
        })
    }

    let gridData = getCheckListGridItemStructure(sameBreakSameCampaign, 'Same Break Same Campaign');
    return gridData;

}

export const getBackToBackClientsInSchedule = async (data) => {

    let allChildrens = [];
    let backToBackClientMediaList = [];

    if (data.length != 0) {
        data.map((parent) => {
            allChildrens = [...allChildrens, ...parent.children];
        })
    }

    //allChildrens orderBy SlotDateTime
    allChildrens.sort((a, b) => (a.SlotDateTime > b.SlotDateTime) ? 1 : -1);

    for (let i = 0; i < allChildrens.length - 1; i++) {
        if (allChildrens[i].Type > SCHEDULETYPE.Segment && allChildrens[i].Client != undefined && allChildrens[i + 1].Client != undefined) {
            if (allChildrens[i].Client != undefined && allChildrens[i + 1].Client != undefined && allChildrens[i].Client._id == allChildrens[i + 1].Client._id) {
                backToBackClientMediaList.push(allChildrens[i]);
            }
        }
    }

    let gridData = getCheckListGridItemStructure(backToBackClientMediaList, 'Media with back to back same client');
    return gridData;

}

export const getPlanningForMediaRepetition = async (data = [], planningMediaData = []) => {

    let planningForMediaRepetition = [];
    data.map((x) => {
        planningMediaData.map((y) => {
            if (x._id !== y._id && x.MediaEpisode_id == y.MediaEpisode_id) {
                planningForMediaRepetition.push(x);
            }
        })
    })
    let gridData = getCheckListGridItemStructure(planningForMediaRepetition, `Planning for media repetition`);
    return gridData;

}

export const validateSamePromoInProgram = async (data) => {
    let gridData = [];
    let invalid = [];
    
    for (const element of data) {
        
        let attachedMedia = await API.getData(ENTITYNAME.MediaEpisode, { query: ['Media._id', '=', element.mediaEpisode._id.toString()] });
        console.log(attachedMedia);

        if(attachedMedia && attachedMedia.success && attachedMedia.data.length > 0){
            let invalidShortForm = element.children.find((x) =>  x.MediaEpisode_id && attachedMedia.data.some((y) => x.MediaEpisode_id == y._id) );
            if(invalidShortForm) invalid.push(invalidShortForm);
        }

    }
    gridData = getCheckListGridItemStructure(invalid, 'Cannot attach same promo in a program');
    return gridData;
}

